import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util'

const container = theme => css`
  margin: ${rem(56)} auto;
  color: ${theme.color.monochrome.black};
  max-width: ${rem(500)};
`

const teammatesRaidoBtn = css`
  label {
    min-width: ${rem(150)};
  }
`

export const styles = {
  container,
  teammatesRaidoBtn,
}
